import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { STEPS } from '../utils/constants';
import { formatSelectedSlot, titlise } from '../utils/helpers';

export const Stepper = () => {
  const { pathname } = useLocation();
  const { treatment, patientType, selectedSlot, patientDetails, preferredTimeSlots } = useSelector((s: RootState) => s.appointment);
  const activeIndex = STEPS.findIndex(s => pathname.includes(s.path));

  const getStepSelection = (idx: number) => {
    switch (idx) {
      case 0:
        return treatment?.title;
      case 1:
        return patientType ? `${titlise(patientType)} Patient` : null;
      case 2:
        if (selectedSlot) {
          return formatSelectedSlot(selectedSlot);
        }
        if (preferredTimeSlots && preferredTimeSlots.length > 0) {
          return `${preferredTimeSlots.length} preferred slots`;
        }
        return null;
      case 3:
        if (patientDetails.firstName || patientDetails.lastName) {
          return `${patientDetails.firstName} ${patientDetails.lastName}`.trim();
        }
        return null;
      default:
        return null;
    }
  };

  return (
    <div className="pt-8">
      <ol className="relative space-y-14">
        <span aria-hidden className="absolute left-[16px] top-0 bottom-0 w-1 bg-gray-200" />
        {STEPS.map((s, idx) => {
          const isActive = idx === activeIndex;
          const isCompleted = idx < activeIndex;
          const selection = isCompleted ? getStepSelection(idx) : null;

          return (
            <li key={s.key} className={'relative flex items-center gap-3'}>
              <span aria-hidden className={`absolute left-[18px] -z-10 top-0 bottom-0 w-0.5 ${isCompleted || isActive ? 'bg-teamcare-yellow' : 'bg-transparent'}`} />
              <span className={`inline-flex items-center justify-center w-9 h-9 rounded-full text-xs font-semibold border relative z-10 ${isCompleted ? 'bg-teamcare-yellow shadow-[2px_2px_0_0_rgba(0,0,0,100)] text-white border-white' : isActive ? 'border-teamcare-yellow text-teamcare-yellow bg-white' : 'border-gray-300 text-gray-500 bg-white'}`}>
                {isCompleted ? (
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-7.25 7.25a1 1 0 01-1.414 0l-3-3a1 1 0 111.414-1.414L8.5 11.586l6.543-6.543a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                ) : (
                  idx + 1
                )}
              </span>
              <div className="flex flex-col min-w-0">
                <span className={`text-xs uppercase tracking-wide font-bold ${isActive ? 'text-teamcare-yellow' : 'text-gray-400'}`}>Step {idx + 1}</span>
                <span className={`text-sm font-semibold ${isActive ? 'text-gray-900' : isCompleted ? 'text-gray-700' : 'text-gray-500'}`}>{s.label}</span>
                {selection && (
                  <div className="h-0 relative overflow-visible">
                    <span className={`text-[11px] text-gray-400 font-medium absolute top-0 left-0 w-full max-w-[160px] leading-tight ${idx === 2 ? 'lg:whitespace-nowrap whitespace-normal' : 'whitespace-normal'
                      }`}>
                      {selection}
                    </span>
                  </div>
                )}
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
};


